<div class="contenitore" *ngIf="!showReward">
  <div class="contenitore_titolo" style="font-size: 26px; line-height: 30px;">Giornata mondiale<br />dell'amicizia</div>

  <app-scratch-card
    imgStart="/assets/img/amicizia_1.jpg"
    imgEnd="/assets/img/amicizia_2.jpg"
    (showReward)="showReward = true"
    [percentage]="70"
  ></app-scratch-card>

  <div class="contenitore_descrizione">
    Scorri il dito sopra l'immagine per scoprire il valore dell'amicizia.
  </div>
</div>

<!-- ATTENZIONE - Mostrare questo contenuto dopo aver grattato la superficie -->
<app-reward *ngIf="showReward"></app-reward>